// 表示用フォーマットユーティリティ
export function formatCurrency(value: number | null | undefined): string {
  if (value == null) return '¥0';
  return '¥' + Number(value).toLocaleString('ja-JP');
}

export function formatNumber(value: number | null | undefined): string {
  if (value == null) return '0';
  return Number(value).toLocaleString('ja-JP');
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '';
  return value.slice(0, 10);
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '';
  return value.replace('T', ' ').slice(0, 16);
}

export function statusLabel(status: string): string {
  const m: Record<string, string> = {
    draft: '下書き', issued: '発行済', ordered: '受注済', lost: '失注',
    active: '進行中', done: '完了', canceled: '取消',
    paid: '入金済', partial: '一部入金'
  };
  return m[status] || status;
}
